var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userInfo.info.user_type==1)?_c('geek-attest-edit'):_c('employer-attest-edit')}
var staticRenderFns = []

export { render, staticRenderFns }